export const BuildVersion = {
    Version: 'main',
    Build: '4ab17ef1',
    Branch: 'develop'
};